import { Switch as BaseSwitch } from '@base-ui/react/switch';
import type { ComponentProps } from 'react';
import { cx } from '@/cva.config';

export interface SwitchProps
  extends Omit<ComponentProps<typeof BaseSwitch.Root>, 'render'> {
  label?: string;
}

export const Switch = ({ label, className, ...rest }: SwitchProps) => {
  const root = (
    <BaseSwitch.Root
      className={cx(
        'relative inline-flex h-4 w-7 shrink-0 items-center rounded-full border border-border bg-surface-sunken transition-colors focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-surface data-checked:border-accent data-checked:bg-accent',
        className,
      )}
      {...rest}
    >
      <BaseSwitch.Thumb className="size-3 translate-x-0.5 rounded-full bg-foreground transition-transform data-checked:translate-x-3 data-checked:bg-white" />
    </BaseSwitch.Root>
  );

  return !label ? (
    root
  ) : (
    <label
      className="inline-flex items-center gap-2 text-sm lg:text-base text-foreground"
      htmlFor={rest.id ?? undefined}
    >
      {root}
      <span>{label}</span>
    </label>
  );
};
